// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal_label[data-v-8c547650]{margin-bottom:8px}", ""]);
// Exports
module.exports = exports;
